import { all, put, select, takeLatest } from 'redux-saga/effects'
import { SagaIterator } from 'redux-saga'

import { authenticationSaga } from '~/account/model/sagas'
import { dashboardSaga } from '~/dashboard/model/sagas'
import { basketSaga } from '~/basket/model/sagas'
import { profileSaga } from '~/profile/model/sagas'
import { updateBasketConfig, clearBasket, addShipment } from '~/basket/model/session/actions'
import { updateDashboardConfig } from '~/dashboard/model/actions'
import { ACTIONS as ACCOUNT_ACTIONS } from '~/account/model/actions'
import { selectIsParcelShop } from '~/account/model/selectors'
import { addressBookSaga } from '~/address-book/model/saga'
import { loadDefaultShipper } from '~/basket/model/actions'

function* handleLoginSuccess(): SagaIterator {
  const state = yield select()

  const { isParcelShop } = selectIsParcelShop(state)

  yield put(
    updateDashboardConfig({
      isReceiptDisplayEnabled: isParcelShop,
    })
  )

  yield put(
    updateBasketConfig({
      defaultDeliveryOptionKey: isParcelShop ? 'DOOR' : null,
      isEmailSubscriptionEnabled: !isParcelShop,
      isParcelshopPaymentEnabled: isParcelShop,
      isAutocompleteEnabled: !isParcelShop,
      isAddressBookEnabled: !isParcelShop,
      isDefaultParcelTypeKeyEnabled: false,
      isTrackerCodeEnabled: isParcelShop,
      isEmailReceiverRequired: !isParcelShop,
    })
  )

  yield put(clearBasket())
  yield put(addShipment())
  yield put(loadDefaultShipper())
}

function* syncBasketAndUserSaga() {
  yield all([takeLatest(ACCOUNT_ACTIONS.LOGIN_SUCCESS, handleLoginSuccess)])
}

export function* rootSaga() {
  yield all([
    addressBookSaga(),
    authenticationSaga(),
    dashboardSaga(),
    basketSaga(),
    syncBasketAndUserSaga(),
    profileSaga(),
  ])
}
